import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

import { PropType } from 'vue';
import RecursiveChecklistComponent from '@/components/system/components/checklist/RecursiveChecklistComponent.vue';
import { ChecklistComposable } from '../../../../ecs/completable/Completable';
import ChecklistItemComponent from './ChecklistItemComponent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RecursiveChecklistComponent',
  props: {
  checklist: {
    type: Object as PropType<ChecklistComposable>,
    required: true
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", {
    class: _normalizeClass({
      active: __props.checklist.checklist.value.active,
      complete: __props.checklist.checklist.value.complete
    })
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.checklist.children, (child, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: index + 600
      }, [
        _createVNode(ChecklistItemComponent, {
          item: child,
          description: child.checklist.value.description.description,
          subtitle: child.checklist.value.description.subtitle,
          complete: child.checklist.value.complete,
          active: child.checklist.value.active,
          "user-selected-active": child.checklist.value.userSelectedActive,
          "user-selected-complete": child.checklist.value.userSelectedComplete,
          compromised: child.checklist.value.compromised
        }, null, 8, ["item", "description", "subtitle", "complete", "active", "user-selected-active", "user-selected-complete", "compromised"]),
        _createVNode(RecursiveChecklistComponent, { checklist: child }, null, 8, ["checklist"])
      ]))
    }), 128))
  ], 2))
}
}

})